export default __webpack_public_path__ + "static/media/cloud2.8735ec07.svg";